// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"454":"471e71c6","648":"95663773","667":"22cd5dbb","776":"3c233b57","817":"25520295"}[chunkId] + ".chunk.css";
};